export class ContactoEmpresa {
  nombre: string;
  correo: string;
  telefono: string;
  identificacion: string;
}
